// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3wOYh","colCheckbox":"styles_colCheckbox__AHvaC"};